import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconKeyboardDoubleArrowLeftSvg } from "./IconKeyboardDoubleArrowLeftSvg.mjs";
const IconKeyboardDoubleArrowLeft = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconKeyboardDoubleArrowLeftSvg, ...iconProps });
};
export {
  IconKeyboardDoubleArrowLeft
};
